<template>
  <div
    class="ui-bar-element"
    :class="[
      { 'ui-bar-element--has-separator': hasSeparator },
      { 'ui-bar-element--is-align-right': isAlignRight }
    ]"
  >
    <span v-if="icon" class="ui-bar-element__icon-container" :class="[`has-background-${icon.backgroundColor}`]">
      <span v-if="icon.customIcon" class="ui-bar-element__icon" :style="`backgroundImage: url('${icon.customIcon}')`"></span>
      <b-icon
        v-if="icon.icon"
        size="is-small"
        :type="`is-${icon.color}`"
        class="ui-bar-element__icon"
        :pack="icon.pack"
        :icon="icon.icon"
      />
    </span>
    <span
      v-if="text"
      class="ui-bar-element__text has-text-weight-bold"
      :class="[
        `has-text-${color}`,
        { 'is-block is-uppercase is-size-7': isUppercase },
        { 'mr-16px': type === 'count-item' },
        { 'ml-16px': type !== 'count-item' },
        { 'ui-bar-element__text--has-max-width': hasMaxWidth }
      ]"
    >
      <span
        v-if="(count || isSpecific || !hideWhenZero) && type === 'label-item'"
        class="is-block is-size-6 has-text-weight-bold"
      >
        {{ count }}
      </span>
      {{ text }}
    </span>
    <span v-if="type === 'count-item'" class="ui-bar-element__count is-block is-size-5 has-text-weight-bold">
      {{ count }}/{{ total }}
    </span>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    text: String,
    color: String,
    count: Number,
    total: Number,
    icon: Object,
    isUppercase: Boolean,
    hasSeparator: Boolean,
    isAlignRight: Boolean,
    hasMaxWidth: Boolean,
    isSpecific: Boolean,
    hideWhenZero: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss">
$icon-container-width: 36px;
$icon-width: 18px;
$icon-height: 16px;
$text-max-width: 84px;

.ui-bar-element {
  & {
    display: flex;
    min-width: 150px;
    white-space: nowrap;
    align-items: center;
  }

  &--is-align-right {
    margin-left: auto;
    margin-right: 0;
  }

  &--has-separator {
    padding-bottom: $space-16px;
    border-bottom: 1px solid $grey-lighter;

    @include tablet {
      padding-bottom: 0;
      padding-right: $space-24px;
      border-bottom-width: 0;
      border-right: 1px solid $grey-lighter;
    }
  }

  &__icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $icon-container-width;
    height: $icon-container-width;
    border-radius: 5px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    width: $icon-width;
    height: $icon-height;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  &__text {
    line-height: 1.2;

    &--has-max-width {
      max-width: $text-max-width;
    }
  }

  &__count {
    line-height: 1;
    position: relative;
    top: -1px;
  }
}
</style>